import React, { useContext, useEffect, useState } from 'react';

import Banner from '../../b2b-common/Banner';
import { CircularProgress, Paper } from '@mui/material';
import { LoginContext } from '../../../App';
import { callAPIWhileSettingState, fetchAPIDataWhileSettingState, generateTextField, handleObjectFieldChange } from '../../b2b-common/helpers';
import { Search } from '@mui/icons-material';

import './LabelsNotFoundListPage.css';
import { getKeyTranslations, getNotFoundLanguageList_Paged } from '../../../services/b2b-languages-apiService';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import LabelsNotFoundTable from '../components/LabelsNotFoundTable';
import LabelNewModal from '../forms/LabelNewModal';

const LabelsNotFoundListPage = () => {
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    const [refresh, setRefresh] = useState(true);
    const [searchFields, setSearchFields] = useState({
        locale: '',
        key: '',
    });
    const [labelsData, setLabelsData] = useState(null);

    const { loginData } = useContext(LoginContext);

    useEffect(() => {
        //console.log(labelsData);
        if (labelsData)
            setPagesCount(labelsData.totalPages);
    }, [labelsData]);

    const fetchNotFoundLabelsData = async (page) => {
        try {
            const paramsArray = [
                page - 1,
                15,
                searchFields,
                loginData.accessToken
            ];
            callAPIWhileSettingState(getNotFoundLanguageList_Paged, paramsArray,
                setLoading, setLabelsData);
        } catch (error) {
            setError(error.message);
        }
    };

    const fetchAllKeyTranslations = async (key) => {
        try {
            const paramsArray = [
                key,
                loginData.accessToken
            ];
            return await fetchAPIDataWhileSettingState(getKeyTranslations, paramsArray, null);
        } catch (error) {
            setError(error.message);
        }
    };

    useEffect(() => {
        if (page !== 0) {
            fetchNotFoundLabelsData(page);
            setRefresh(false);
        }
    }, [page, refresh]);

    const handlePageChange = (event, value) => {
        setPage(value);
        setRefresh(true);
    };

    const handleClickSearch = async () => {
        fetchNotFoundLabelsData(1);
        setPage(1);
    };

    const [showNewLabelTranslation, setShowNewLabelTranslation] = useState(false);
    const emptyTranslation = {
        sameLabelTranslations: [],
        allLocales: []
    };
    const [labelTranslations, setLabelTranslations] = useState(emptyTranslation);

    const handleSelectNotFoundLabel = async (notFoundLabelRowInTable) => {
        //console.log(notFoundLabelRowInTable);
        setLabelTranslations(emptyTranslation);
        const key = notFoundLabelRowInTable.key;
        const otherTranslations = await fetchAllKeyTranslations(key);
        //console.log(otherTranslations);
        const existingTranslationIndex = otherTranslations.sameLabelTranslations.findIndex(
            translation => translation.key === notFoundLabelRowInTable.key && translation.locale === notFoundLabelRowInTable.locale
        );
        const updatedTranslations = {
            sameLabelTranslations: existingTranslationIndex === -1
                ? [
                    ...otherTranslations.sameLabelTranslations,
                    notFoundLabelRowInTable
                ]
                : otherTranslations.sameLabelTranslations,
            allLocales: otherTranslations.allLocales
        };
        setLabelTranslations(updatedTranslations);
        setShowNewLabelTranslation(true);
    };

    const buttonsConfig = [
        {
            label: 'Search',
            onClick: handleClickSearch,
            isLoading: loading,
            color: 'secondary',
            variant: 'contained',
            key: '2',
            icon: <Search />,
        },
    ];

    return (
        <div className='labels-notfound-list-page'>
            <Banner message="Languages Menu: List of not found labels" className='labels-list-page-banner' />
            <B2BFormContainer title="Search form" className="labels-notfound-search-form" orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
                {generateTextField("Locale", searchFields.locale, "labels-notfound-search-field-locale", false, (e) => handleObjectFieldChange('locale', e.target.value, setSearchFields), { required: false })}
                {generateTextField("Key", searchFields.key, "labels-notfound-search-field-key", false, (e) => handleObjectFieldChange('key', e.target.value, setSearchFields), { required: false })}
            </B2BFormContainer>
            <Paper className="labels-notfound-search-form-container">
            </Paper>
            {loading && <CircularProgress className="centered-spinner" />}
            {error && <p>Error: {error}</p>}
            {!loading && labelsData && (
                <LabelsNotFoundTable
                    labelsPagedData={labelsData}
                    onSelectLabel={handleSelectNotFoundLabel}
                    pagesCount={pagesCount}
                    currentPage={page}
                    onPageChange={handlePageChange}
                    className={'labels-notfound-table'}
                />
            )}
            {showNewLabelTranslation && (
                <LabelNewModal
                    open={showNewLabelTranslation}
                    labelTranslations={labelTranslations}
                    onUserUpdate={null}
                    onClose={() => setShowNewLabelTranslation(false)}
                />
            )}
        </div>
    );
}

export default LabelsNotFoundListPage;